import { NeutralColors } from "@fluentui/react";

export const MISSING_STRATIGRAPHY_COLOR = NeutralColors.gray50;
export const MISSING_STRATIGRAPHY_NAME = "Undefined";

export const MINIMUM_ZOOM_AREA_SIZE = 10;
